var REJECT_LIST = [
    "00000000000",
    "11111111111",
    "22222222222",
    "33333333333",
    "44444444444",
    "55555555555",
    "66666666666",
    "77777777777",
    "88888888888",
    "99999999999",
];
var STRICT_STRIP_REGEX = /[.-]/g;
var LOOSE_STRIP_REGEX = /[^\d]/g;
export function verifierDigit(numbers) {
    var numberList = numbers.split("").map(function (number) { return parseInt(number, 10); });
    var modulus = numberList.length + 1;
    var multiplied = numberList.map(function (number, index) { return number * (modulus - index); });
    var mod = multiplied.reduce(function (buffer, number) { return buffer + number; }) % 11;
    return mod < 2 ? 0 : 11 - mod;
}
export function format(cpf) {
    return strip(cpf).replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
}
export function cleanned(value) {
    var cleannedValue = value.replace(/ +?/g, "");
    cleannedValue = value.replace(/(~|`|!|@|#|$|%|^|&|\*|\(|\)|{|}|\[|\]|;|:|\"|'|<|,|\.|>|\?|\/|\\|\||-|_|\+|=)/g, "");
    return cleannedValue;
}
export function strip(cpf, isStrict) {
    if (isStrict === void 0) { isStrict = false; }
    var regex = isStrict ? STRICT_STRIP_REGEX : LOOSE_STRIP_REGEX;
    return (cpf || "").toString().replace(regex, "");
}
export function isValid(cpf, isStrict) {
    if (isStrict === void 0) { isStrict = false; }
    var stripped = strip(cpf, isStrict);
    if (!stripped) {
        return false;
    }
    if (stripped.length !== 11) {
        return false;
    }
    if (REJECT_LIST.includes(stripped)) {
        return false;
    }
    var numbers = stripped.substring(0, 9);
    numbers += verifierDigit(numbers);
    numbers += verifierDigit(numbers);
    return numbers.substring(-2) === stripped.substring(-2);
}
export function generate(useFormat) {
    if (useFormat === void 0) { useFormat = false; }
    var numbers = "";
    for (var i = 0; i < 9; i += 1) {
        numbers += Math.floor(Math.random() * 9);
    }
    numbers += verifierDigit(numbers);
    numbers += verifierDigit(numbers);
    return useFormat ? format(numbers) : numbers;
}
